import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5d2efb36"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 1,
  class: "project-info"
};
const _hoisted_2 = {
  class: "project-title"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "project-title-logo",
  src: "https://p6.moimg.net/md/icon/project_title_icon@2x.png"
}, null, -1));
const _hoisted_4 = {
  class: "snapshot-notice"
};
const _hoisted_5 = {
  class: "notice-text"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "link-text"
}, "查看最新详情页", -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "arrow-icon",
  src: "https://p6.moimg.net/mdwxapp/order_snapshot_arrow_red.png"
}, null, -1));
const _hoisted_8 = [_hoisted_6, _hoisted_7];
const _hoisted_9 = {
  key: 0,
  class: "purchased-reward"
};
const _hoisted_10 = {
  class: "purchased-text"
};
import { ref, onMounted, nextTick } from 'vue';
import { useRoute } from 'vue-router';
import Error from '@@/common/Error.vue';
import CompTopSwiper from '@@/project/topSwiper.vue';
// import CompInitiator from '@@/project/initiator.vue'
import { getOrderSnapshotDetail } from '@api';
import cont_match_reg from "@/utils/editor.js";
import { observeVideo } from "md-base-tools/editor/gitvideo";
import MDRouter from '../../service/router';
export default {
  setup(__props) {
    const route = useRoute();
    const showError = ref(false);
    const showMessage = ref('');
    const product_info = ref({
      title: '交易快照'
    });
    //const user_info = ref({})
    const editorBox = ref(null);
    const order_info = ref({});
    const fetchDetail = async () => {
      try {
        const {
          status,
          data
        } = await getOrderSnapshotDetail({
          ...route.query
        });
        if (status == 0) {
          // 先设置基础数据
          order_info.value = data.order_info;
          if (data.product_info) {
            // 等待 DOM 更新后处理富文本渲染
            product_info.value = data.product_info;
            await nextTick();
            if (editorBox.value) {
              if (data.product_info && data.product_info.content) {
                editorBox.value.appendChild(cont_match_reg(`<p>${data.product_info.content}</p>`));
              }

              // 处理视频观察
              //await nextTick()
              observeVideo(editorBox.value, process.env.VUE_APP_ENV);
            }
          } else if (data.mall_info && data.mall_info.product) {
            product_info.value.product_id = data.mall_info.product.product_id;
            product_info.value.title = data.mall_info.product.name;
            product_info.value.logo_1x1 = data.mall_info.product.img_url;
            product_info.value.wb_logos = data.mall_info.product.imgs;

            // 等待 DOM 更新后处理富文本渲染
            await nextTick();
            if (editorBox.value) {
              if (data.mall_info && data.mall_info.details && data.mall_info.details.detail) {
                editorBox.value.appendChild(cont_match_reg(`<p>${data.mall_info.details.detail}</p>`));
              }

              // 处理视频观察
              observeVideo(editorBox.value, process.env.VUE_APP_ENV);
            }
          }
        } else {
          showError.value = true;
          showMessage.value = data.message || '获取详情失败';
        }
      } catch (e) {
        showError.value = true;
        showMessage.value = '网络错误';
      }
    };

    // 跳转到最新详情页
    const goToLatestDetail = () => {
      if (product_info.value.id) {
        MDRouter.goProInfo(product_info.value.id);
      } else if (product_info.value.product_id) {
        MDRouter.goMallInfo(product_info.value.product_id);
      }
    };
    onMounted(() => {
      fetchDetail();
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", null, [showError.value ? (_openBlock(), _createBlock(Error, {
        key: 0,
        message: showMessage.value
      }, null, 8, ["message"])) : (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(CompTopSwiper, {
        product_info: product_info.value
      }, null, 8, ["product_info"]), _createElementVNode("div", _hoisted_2, [_hoisted_3, _createTextVNode(" " + _toDisplayString(product_info.value.title), 1)]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, _toDisplayString(order_info.value.content_describe || '当前页面内容为订单快照，包含订单创建时众筹详情页，买卖双方和平台发生交易争议时，该页面作为判定依据'), 1), _createElementVNode("div", {
        class: "latest-link",
        onClick: goToLatestDetail
      }, _hoisted_8)]), order_info.value.order_product ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("span", _hoisted_10, _toDisplayString(order_info.value.order_product), 1)])) : _createCommentVNode("", true), _createElementVNode("div", {
        ref_key: "editorBox",
        ref: editorBox
      }, null, 512)]))]);
    };
  }
};